// extracted by mini-css-extract-plugin
export default {"locationCard":"LocationCard_locationCard__iEpWo","locationCard__img":"LocationCard_locationCard__img__8+i-F","locationCard__title":"LocationCard_locationCard__title__l43pj"};